export type ApiTimeTrackingLog = {
    id: number,
    createdAtUtc: string,
    changedAtUtc: string,
    documentKey: string,

    authorId: number,
    workerId: number,
    teamId: number,
    commentId: number,
    description: string,
    leftMin: number,
    spentTimeMode: SpentTimeMode,
    leftTimeMode: LeftTimeMode,
    spentMin: number,
    startAtUtc: string,
    relatedDocumentKeys: string[],
    serviceData: any,
}

export enum LeftTimeMode {
    Reduce = 'reduce',
    Keep = 'keep',
    SetNewValue = 'set',
}

export enum SpentTimeMode {
    Reduce = 'reduce',
    Keep = 'keep',
}

export type ApiCreateTimeTrackingLogData = {
    spentMin: number,
    startAtUtc?: Date,
    spentTimeMode?: SpentTimeMode,
    leftTimeMode?: LeftTimeMode,
    leftMin?: number,
    description?: string,
    relatedDocumentKeys?: string[],
    workerId?: number,
    teamId?: number,
}

export type ApiGetTimeTrackingListParams = {
    withRelatedDocuments: boolean,
}
